import { render, staticRenderFns } from "./situationStatistics.vue?vue&type=template&id=6ad39798&scoped=true&"
import script from "./situationStatistics.vue?vue&type=script&lang=js&"
export * from "./situationStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad39798",
  null
  
)

export default component.exports